import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplateDetailsComponent } from './pages/template-details/template-details.component';
import { TemplateComponent } from './pages/template/template.component';
import { WrapperComponent } from './pages/wrapper/wrapper.component';
import { TemplateCoursesResolver, TemplateResolver, TemplatesResolver } from '@modules/template/student/store/resolvers';
import { CountryResolver } from '@shared/resolvers/country.resolver';
import { CultureResolver } from '@shared/resolvers/culture.resolver';
import { LocationListResolver } from '@modules/location/store/services/location.list.resolver';
import { CourseOverviewResolver } from './store/resolvers/course-overview.resolver';
import { TemplateHighspeedCoursesComponent } from './pages/template-highspeed-courses/template-highspeed-courses.component';
import { TemplateHighspeedCoursesResolver } from './store/resolvers/template-highspeed-courses.resolver';
import { TemplateRequestComponent } from "@modules/template/student/pages/template-request/template-request.component";

const routes: Routes = [
  {
    path: '',
    component: WrapperComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: TemplateComponent,
        resolve: [CourseOverviewResolver],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'informasjon/hoyhastighetsbevis',
        component: TemplateHighspeedCoursesComponent,
        resolve: [TemplateHighspeedCoursesResolver],
        pathMatch: 'full'
      },
      {
        path: 'request',
        component: TemplateRequestComponent,
        resolve: { templates: TemplatesResolver, regions: LocationListResolver  },
        pathMatch: 'full'
      },
      {
        path: ':id',
        component: TemplateDetailsComponent,
        resolve: [TemplateResolver, TemplateCoursesResolver, CountryResolver, CultureResolver, LocationListResolver],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TemplateRoutingModule {}
